import React, {ReactElement} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {closeEndPresentationAction, endPresentationAction} from '../../store/actions/chalkBoardElements.actions';
import {askToEndPresentationModuleSelector} from '../../store/selectors/presentation.selectors';
import ConfirmModal from '../../incase-domain/components/modals/confirmModal/ConfirmModal';

function EndPresentationModal(): ReactElement {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const navigate = useNavigate();
    const askToEndPresentationModule = useSelector(askToEndPresentationModuleSelector);

    return (
        <div data-cy="end-presentation-modal">
            <ConfirmModal
                isOpen={askToEndPresentationModule}
                color="info"
                icon="solar:exit-bold"
                onConfirm={() => dispatch(endPresentationAction(navigate))}
                confirmText={t('playerPage.endPresentationModal.endPresentation')}
                showCancel
                onCancel={() => dispatch(closeEndPresentationAction())}
                message={`${t('playerPage.endPresentationModal.youWontBeAbleToReturn')}`}
                title={`${t('playerPage.endPresentationModal.endPresentation')}?`}
            />
        </div>
    );
}

export default EndPresentationModal;
